(function () {
  'use strict';

  var TOAST_VISIBLE_MS = 2800;
  var TOAST_FADE_MS = 200;

  var toast = null;
  var toastMessage = null;
  var hideTimer = null;

  function getToast() {
    if (toast) return toast;
    toast = document.getElementById('CartToast');
    if (toast) {
      toastMessage = toast.querySelector('.cart-toast__message');
    }
    return toast;
  }

  function showToast(message, isError) {
    var el = getToast();
    if (!el || !toastMessage) return;

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    toastMessage.textContent = message;
    el.classList.toggle('cart-toast--error', !!isError);
    el.hidden = false;

    // Force reflow so the transition fires every time, not just the first.
    void el.offsetWidth;
    el.classList.add('cart-toast--visible');

    hideTimer = setTimeout(function () {
      el.classList.remove('cart-toast--visible');
      setTimeout(function () { el.hidden = true; }, TOAST_FADE_MS);
    }, TOAST_VISIBLE_MS);
  }

  function setLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('quick-add-btn--loading');
    } else {
      button.removeAttribute('disabled');
      button.classList.remove('quick-add-btn--loading');
    }
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    var title = button.getAttribute('data-product-title') || 'Item';
    if (!variantId) return;

    setLoading(button, true);

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var msg = (result.data && result.data.description) || 'Could not add to cart.';
          showToast(msg, true);
          return;
        }
        showToast(title + ' added to cart');
        // Refresh the cart drawer/header count without opening the drawer.
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        showToast('Network error. Please try again.', true);
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-quick-add]');
    if (!button) return;
    if (button.hasAttribute('disabled')) return;
    evt.preventDefault();
    evt.stopPropagation();
    addToCart(button);
  });
})();
